// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-befa {
  font-family: 'Montserrat' !important;
}

/* Full layout */
.chat-wrapper {
  display: flex;
  width: 100%;
  height: 100vh;
  background: linear-gradient(to bottom, #eef6ff, #ffffff);
  font-family: "Inter", sans-serif;
  overflow: hidden;
}

/* === Chat main area === */
.chat-main {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  transition: all 0.3s ease;
  margin-left: 10px;
  overflow: hidden;
  height: 100vh;
  padding: 0; /* hilangkan padding besar */
}

.chat-main.collapsed {
  margin-left: 0px; /* width sidebar collapse */
}

/* Welcome */
.welcome {
  text-align: center;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 60px;
}

/* Typography */
.welcome h1 {
  font-size: 26px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 24px;
}

.welcome h1 span {
  color: #000000;
}

/* Update box */
.update-box {
  position: relative;
  background: #F5F5F6;
  border-radius: 10px;
  padding: 14px 18px 0px 18px;
  margin-bottom: 24px;
  font-size: 13px;
  line-height: 1.5;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

  /* tetap menempati ruang, tapi kontennya bisa disembunyikan */
}
.icon-cell {
  display: flex;
  justify-content: center; /* horizontal center */
  align-items: center; /* vertical center */
  padding-top: 15px;
  padding-left: 10px;
  margin-right: -20px;
}


.update-box.hidden-content {
  visibility: hidden;
}

/* Close button */
.update-box .close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #777;
}

.update-button-box{
  display: flex;
  justify-content: space-between; /* pushes left & right apart */
  align-items: center;            /* optional: vertical align */
  margin-top: -20px;
}
.update-button {
  background-color: #F5F5F6;
  padding: 10px;
  border-radius: 8px;
  border: 0;
  font-size: 12px;
  width: 220px;

  display: flex;              /* 👈 important */
  align-items: center;
}

.btn-icon {
  margin-right: 5px;
  font-size: 15px;
}

.btn-arrow {
  margin-left: auto;          /* 👈 pushes arrow to the far right */
  display: flex;
  align-items: center;
}

.update-button:hover{
  background-color: #D6EBF6;
}

/* Quick actions */
.quick-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quick-actions button {
  background: white;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  color: #333;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s;
}

.quick-actions button:hover {
  background: #f4f8ff;
}

/* Chat input */
.chat-input {
  position: relative;
  width: 60%;
  background: #e8f1fd;
  border-radius: 50px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.chat-input input {
  flex: 1 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 13px;
  color: #333;
}

.input-icon-left {
  margin-right: 10px;
  color: #4b73a1;
}


.form-input-wrapper {
  position: relative;
  display: flex;
  align-items: flex-end;
  padding: 8px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 12px;
}

.textarea-wrapper {
  flex: 1 1;
}

.textarea-wrapper textarea {
  width: 100%;
  resize: none;
  border: none;
  outline: none;
  font-size: 13px;
  line-height: 1.4;
  padding: 8px;
  border-radius: 8px;
  max-height: 200px;
}

.attach-icon {
  width: 22px;
  height: 22px;
  margin-left: 8px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.attach-icon:hover {
  opacity: 1;
}

.chat-input-wrapper {
  position: absolute;
  min-height: 120px;
  bottom: -1.2vw;
  left: 50%;
  transform: translateX(-50%);
  width: 85%;
  z-index: 10;
  padding-bottom: 35px;
}

/* Bubble biru auto expand */
.chat-input-inner {
  box-sizing: border-box;
  flex-direction: column;
  gap: 6px;
  display: flex;
  flex-direction: column;
  background-color: #eef6ff;
  border-radius: 28px;
  padding: 10px 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  transition: all 0.25s ease;
}

.chat-input-wrapper textarea {
  flex: 1 1;
  resize: none;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  padding: 6px 0 4px 0; /* rapikan padding agar tinggi pas */
  max-height: 180px;
  min-height: 24px;
}

.input-icon-left,
.input-icon-right {
  color: #404041;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.2s;
}

.input-icon-left:hover,
.input-icon-right:hover {
  opacity: 0.7;
  color: #0296D2;
}


/* Chat bubbles */
.chat-messagesbak {
  width: 85%;
  padding: 0 0 120px 0; /* ruang sedikit untuk input */
  margin: -10px 0 100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.chat-messages {
  width: 85%;
  padding: 0 0 0 0; /* ruang sedikit untuk input */
  margin: 10px 0 0 7.5%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.rightScroll {
  min-width: 100%;
  margin-left: 0%;
  flex: 1 1;
  overflow-y: auto;
  max-height: 69%;

  /* For modern browsers (Firefox) */
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent; /* thumb color, track color */
  scrollbar-width: thin;
}

/* For Webkit browsers (Chrome, Safari, Edge) */
.rightScroll::-webkit-scrollbar {
  width: 6px; /* Makes the scrollbar thinner and more elegant */
}

.rightScroll::-webkit-scrollbar-track {
  background: transparent; /* This is what makes the track transparent */
}

.rightScroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2); /* Semi-transparent dark thumb */
  border-radius: 3px; /* Optional: Rounds the corners of the thumb */
}

.rightScroll::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.4); /* Slightly darker on hover for interactivity */
}

.chat-bubble {
  position: relative;
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 14px;
  margin-bottom: 12px;
  line-height: 1.5;
  word-wrap: break-word;
  padding-left: 20px;
}

.user-bubble {
  width: fit-content;
  background: #e8eaed;
  color: #333;
  align-self: flex-end;
  margin-left: auto;
}

.ai-bubble {
  color: #222;
  border: 0px solid #ddd;
  align-self: flex-start;
}

.chat-content{
  font-size: 13px;
}

.chat-content a {
  color: #007bff;
  text-decoration: underline;
}

.chat-content::after {
  content: none !important;
  animation: none !important;
}


.chat-time-ai {
  font-size: 11px;
  color: #888;
  text-align: left;
  margin-top: 4px;
  padding-left: 0px;
  margin-bottom: -5px;
}

.chat-time {
  font-size: 11px;
  color: #888;
  text-align: right;
  margin-top: 4px;
  padding-left: 20px;
}

.send-btn {
  background: transparent;
  border: none;
  margin-left: 4px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
}

.send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* 🌐 Globe toggle */
.globe-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
}


.globe-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Tooltip */
.globe-tooltip {
  position: absolute;
  bottom: 38px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  color: #333;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 8px;
  box-shadow: 0px 8px 80px 6px #00000033;
  white-space: nowrap;
  z-index: 50;
}

/* Simple CSS Tooltip */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-container .tooltip-text {
  visibility: hidden;
  background-color: white;
  color: black;
  text-align: center;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%; /* Position above the element */
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
  
  /* Fade in */
  opacity: 0;
  transition: opacity 0.3s;
  
  /* Prevent text selection */
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  
  /* White arrow */
  white-space: nowrap;
  box-shadow: 0px 8px 80px 6px #00000033;
}

.tooltip-container .tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%; /* At the bottom of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: white transparent transparent transparent;

}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

/* Dropdown menu */
.data-source-menu {
  position: absolute;
  bottom: 42px;
  left: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 8px 80px 6px #00000033;
  padding: 8px 0;
  width: 190px;
  z-index: 100;
}

.data-source-menu hr {
  border: none;
  border-top: 1px solid #eee;
  margin: 4px 0;
}

.menu-item-int {
  padding: 8px 14px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu-item-int:hover {
  background: #E8E9EB;
}

.check {
  color: #2b6cb0;
  font-weight: bold;
}

/* Info bawah input */
/* ====== Container info bawah chat ====== */
.selected-info {
  position: relative;
  margin-top: 10px; /* jarak dari chat input */
  left: 0;
  transform: none;
  bottom: 0;
  width: 100%;
  font-size: 13px;
  color: #2b6cb0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  justify-content: flex-start;
  padding-left: 10px;
}

/* Kotak utama sumber aktif */
.source-box {
  background-color: #f1f3f5;
  border-radius: 20px;
  padding: 6px 10px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  white-space: nowrap;
  position: relative; /* ini penting agar .source-list posisinya relatif terhadap kotak ini */
}

.source-box:hover {
  background-color: #e1e5e9;
  transform: translateY(-1px);
}

/* Daftar badge keluar ke kanan dari kotak sumber */
.source-list {
  position: absolute;
  top: 50%;
  left: calc( var(--source-box-right, 0px) + 270px );
/* muncul persis di sisi kanan .source-box */
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 10px; /* jarak kecil dari box sumber */
  z-index: 10;
}

.source-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  background: #F5F5F6;
  color: #0296D2;
  border-radius: 20px;
  padding: 6px 12px 6px 10px;
  margin: -150px;
  font-size: 13px;
  transition: background 0.2s;
}

.source-item:hover{
  background: #E1F2FA;
}

/* Tombol X kiri */
.remove-btn {
  display: none;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  margin-right: 6px;
  border: none;
  border-radius: 50%;
  background-color: #b5e0f6;
  color: #007bcb;
  font-size: 13px;
  cursor: pointer;
  line-height: 0;
  padding: 0;
}

.source-item:hover .remove-btn {
  display: flex;
}

.remove-btn:hover {
  background-color: #8dd2f3;
}

/* Pastikan teks tidak tertabrak tombol */
.source-text {
  white-space: nowrap;
}

/* Tooltip wrapper */
.tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Tooltip text (tersembunyi default) */
.tooltip-text {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 120%; /* muncul di atas ikon */
  background-color: #fff;
  color: #000000;
  font-size: 12px;
  padding: 5px 8px;
  border-radius: 6px;
  white-space: nowrap;
  transition: opacity 0.2s ease, transform 0.2s ease;
  transform: translateY(4px);
  z-index: 20;
  box-shadow: 0px 8px 80px 6px #00000033;
}


/* Saat hover ke ikon, tooltip muncul */
.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}

.typing-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 6px 0 10px 6px;
  padding: 6px 12px;
  background: #f3f6fb;
  border-radius: 20px;
  width: fit-content;
}

.typing-indicator .dot {
  width: 6px;
  height: 6px;
  background: #2b6cb0;
  border-radius: 50%;
  animation: blink 1.4s infinite both;
}

.typing-indicator .dot:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-indicator .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
}

/* File preview di dalam input */
.file-preview-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
}

/* Item file */
.file-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: -1px;
}

/* Tombol X */
.remove-file-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 50%;
  padding: 0px;
  color: #444;
  width: 25px;
  height: 25px;
  font-size: 25px;
  line-height: 15px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.remove-file-btn:hover {
  background: #ff4d4f;
  color: white;
  border-color: #ff4d4f;
}

/* Baris utama input */
.input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

/* Textarea */
.input-row textarea {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  resize: none;
  font-size: 13px;
  line-height: 1.4;
  color: #222;
}

.input-row textarea::placeholder {
  color: #7a8aa0;
}


/* Tombol kirim */
.send-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.source-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 4px 8px;
}

.source-item img {
  opacity: 1;
  transition: opacity 0.2s ease;
}

.content-cell {
  padding-left: 40px;
  vertical-align: top;
  text-align: left;
}

.source-item .remove-btn {
  opacity: 0;
  position: absolute;
  left: 0;
  transition: opacity 0.2s ease;
  background: #B5E0F6;
  color: #01648C;
  border: none;
  border-radius: 50%;
  width: 21px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  margin-right: 6px;
  margin-left: 7px;
}

.source-item:hover img {
  opacity: 0;
}

.source-item:hover .remove-btn {
  opacity: 1;
}

.internet-status-icon:hover{
  color: #0296D2;
}

.hoverclass{
  padding: 2px;
}

.hoverclass:hover{
  background:#E8E9EB;
  border-radius: 5px;
  padding: 2px;
}

.chosen{
  background:#D9DBDF;
  border-radius: 5px;
  padding: 2px;
}

.aiModel{
  color: black;
  font-size: 14px;
  margin-top: 3px;
}

.aiModel:hover{
  color: #0296D2;
  cursor: pointer;
}

.aiModel-trigger {
  cursor: pointer;
  width: fit-content;
}

.aiModel-overlay {
  position: fixed;
  inset: 0;
  pointer-events: none; /* important */
}

.aiModel-popup {
  position: absolute;
  bottom: 130px;
  left: 60px;
  pointer-events: auto;
  background-color: white;
  box-shadow: 0px 8px 80px 6px #00000033;
  border-radius: 8px;
  max-height: 200%;
  overflow-y: scroll;
  max-width: 40%;
}

.aiModel-item {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  cursor: pointer;
  margin: 10px;
  border-radius: 8px;
}

.aiModel-item:hover {
  background: #E8E9EB;
}

.aiModel-item.active {
  background: #E8E9EB;
}

.aiModel-label {
  margin-bottom: 5px;
  font-weight: 600;
  color: #666;
}

.aiModel-detail {
  font-size: 12px;
  color: #666;
}

.aiModel-check {
  font-size: 16px;
  color: #666;
}

.chat-bubble.system {
  background: #fff3cd;
  border: 1px solid #ffe69c;
  color: #664d03;
  font-size: 13px;
  line-height: 1.5;
  max-width: 80%;
  margin: 10px auto;
  text-align: left;
}

.chat-bubble.system ul {
  padding-left: 16px;
}`, "",{"version":3,"sources":["webpack://./src/pages/chat/Chat.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,wDAAwD;EACxD,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,UAAU,EAAE,4BAA4B;AAC1C;;AAEA;EACE,gBAAgB,EAAE,2BAA2B;AAC/C;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;;EAEzC,6DAA6D;AAC/D;AACA;EACE,aAAa;EACb,uBAAuB,EAAE,sBAAsB;EAC/C,mBAAmB,EAAE,oBAAoB;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,8BAA8B;EAC9D,mBAAmB,aAAa,6BAA6B;EAC7D,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,YAAY;;EAEZ,aAAa,eAAe,iBAAiB;EAC7C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB,WAAW,qCAAqC;EACjE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB,EAAE,oCAAoC;EAC1D,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;;AAGA,iBAAiB;AACjB;EACE,UAAU;EACV,oBAAoB,EAAE,8BAA8B;EACpD,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gBAAgB,EAAE,8BAA8B;EAChD,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,eAAe;EACf,SAAO;EACP,gBAAgB;EAChB,eAAe;;EAEf,kCAAkC;EAClC,+CAA+C,EAAE,6BAA6B;EAC9E,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,UAAU,EAAE,iDAAiD;AAC/D;;AAEA;EACE,uBAAuB,EAAE,6CAA6C;AACxE;;AAEA;EACE,oCAAoC,EAAE,gCAAgC;EACtE,kBAAkB,EAAE,8CAA8C;AACpE;;AAEA;EACE,oCAAoC,EAAE,+CAA+C;AACvF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;;EAEf,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,YAAY,EAAE,+BAA+B;EAC7C,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;;EAElB,YAAY;EACZ,UAAU;EACV,wBAAwB;;EAExB,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;;EAEpB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,iCAAiC;EAC5C,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;;AAEzD;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,gBAAgB,EAAE,0BAA0B;EAC5C,OAAO;EACP,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,qDAAqD;EACrD,mBAAmB;EACnB,kBAAkB,EAAE,uEAAuE;AAC7F;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,QAAQ;EACR,kDAAkD;AACpD,4CAA4C;EAC1C,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB,EAAE,gCAAgC;EACnD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY,EAAE,wBAAwB;EACtC,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;EAClD,0BAA0B;EAC1B,WAAW;EACX,sCAAsC;AACxC;;;AAGA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB,UAAU,EAAE;EAC5B,MAAM,UAAU,EAAE;AACpB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,aAAa;AACf;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA,aAAa;AACb;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;;AAGA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB,EAAE,cAAc;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".font-befa {\r\n  font-family: 'Montserrat' !important;\r\n}\r\n\r\n/* Full layout */\r\n.chat-wrapper {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background: linear-gradient(to bottom, #eef6ff, #ffffff);\r\n  font-family: \"Inter\", sans-serif;\r\n  overflow: hidden;\r\n}\r\n\r\n/* === Chat main area === */\r\n.chat-main {\r\n  position: relative;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  transition: all 0.3s ease;\r\n  margin-left: 10px;\r\n  overflow: hidden;\r\n  height: 100vh;\r\n  padding: 0; /* hilangkan padding besar */\r\n}\r\n\r\n.chat-main.collapsed {\r\n  margin-left: 0px; /* width sidebar collapse */\r\n}\r\n\r\n/* Welcome */\r\n.welcome {\r\n  text-align: center;\r\n  max-width: 600px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  margin-top: 60px;\r\n}\r\n\r\n/* Typography */\r\n.welcome h1 {\r\n  font-size: 26px;\r\n  font-weight: 600;\r\n  color: #1a1a1a;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.welcome h1 span {\r\n  color: #000000;\r\n}\r\n\r\n/* Update box */\r\n.update-box {\r\n  position: relative;\r\n  background: #F5F5F6;\r\n  border-radius: 10px;\r\n  padding: 14px 18px 0px 18px;\r\n  margin-bottom: 24px;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\r\n\r\n  /* tetap menempati ruang, tapi kontennya bisa disembunyikan */\r\n}\r\n.icon-cell {\r\n  display: flex;\r\n  justify-content: center; /* horizontal center */\r\n  align-items: center; /* vertical center */\r\n  padding-top: 15px;\r\n  padding-left: 10px;\r\n  margin-right: -20px;\r\n}\r\n\r\n\r\n.update-box.hidden-content {\r\n  visibility: hidden;\r\n}\r\n\r\n/* Close button */\r\n.update-box .close-btn {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  color: #777;\r\n}\r\n\r\n.update-button-box{\r\n  display: flex;\r\n  justify-content: space-between; /* pushes left & right apart */\r\n  align-items: center;            /* optional: vertical align */\r\n  margin-top: -20px;\r\n}\r\n.update-button {\r\n  background-color: #F5F5F6;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  border: 0;\r\n  font-size: 12px;\r\n  width: 220px;\r\n\r\n  display: flex;              /* 👈 important */\r\n  align-items: center;\r\n}\r\n\r\n.btn-icon {\r\n  margin-right: 5px;\r\n  font-size: 15px;\r\n}\r\n\r\n.btn-arrow {\r\n  margin-left: auto;          /* 👈 pushes arrow to the far right */\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.update-button:hover{\r\n  background-color: #D6EBF6;\r\n}\r\n\r\n/* Quick actions */\r\n.quick-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.quick-actions button {\r\n  background: white;\r\n  border: 1px solid #dbe3ef;\r\n  border-radius: 8px;\r\n  padding: 8px 14px;\r\n  font-size: 13px;\r\n  color: #333;\r\n  text-align: left;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.quick-actions button:hover {\r\n  background: #f4f8ff;\r\n}\r\n\r\n/* Chat input */\r\n.chat-input {\r\n  position: relative;\r\n  width: 60%;\r\n  background: #e8f1fd;\r\n  border-radius: 50px;\r\n  padding: 10px 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.chat-input input {\r\n  flex: 1;\r\n  border: none;\r\n  background: transparent;\r\n  outline: none;\r\n  font-size: 13px;\r\n  color: #333;\r\n}\r\n\r\n.input-icon-left {\r\n  margin-right: 10px;\r\n  color: #4b73a1;\r\n}\r\n\r\n\r\n.form-input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  padding: 8px;\r\n  background: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 12px;\r\n}\r\n\r\n.textarea-wrapper {\r\n  flex: 1;\r\n}\r\n\r\n.textarea-wrapper textarea {\r\n  width: 100%;\r\n  resize: none;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n  max-height: 200px;\r\n}\r\n\r\n.attach-icon {\r\n  width: 22px;\r\n  height: 22px;\r\n  margin-left: 8px;\r\n  cursor: pointer;\r\n  opacity: 0.7;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.attach-icon:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.chat-input-wrapper {\r\n  position: absolute;\r\n  min-height: 120px;\r\n  bottom: -1.2vw;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 85%;\r\n  z-index: 10;\r\n  padding-bottom: 35px;\r\n}\r\n\r\n/* Bubble biru auto expand */\r\n.chat-input-inner {\r\n  box-sizing: border-box;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #eef6ff;\r\n  border-radius: 28px;\r\n  padding: 10px 16px;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.chat-input-wrapper textarea {\r\n  flex: 1;\r\n  resize: none;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-size: 13px;\r\n  color: #333;\r\n  line-height: 1.4;\r\n  padding: 6px 0 4px 0; /* rapikan padding agar tinggi pas */\r\n  max-height: 180px;\r\n  min-height: 24px;\r\n}\r\n\r\n.input-icon-left,\r\n.input-icon-right {\r\n  color: #404041;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.input-icon-left:hover,\r\n.input-icon-right:hover {\r\n  opacity: 0.7;\r\n  color: #0296D2;\r\n}\r\n\r\n\r\n/* Chat bubbles */\r\n.chat-messagesbak {\r\n  width: 85%;\r\n  padding: 0 0 120px 0; /* ruang sedikit untuk input */\r\n  margin: -10px 0 100px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.chat-messages {\r\n  width: 85%;\r\n  padding: 0 0 0 0; /* ruang sedikit untuk input */\r\n  margin: 10px 0 0 7.5%;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n}\r\n.rightScroll {\r\n  min-width: 100%;\r\n  margin-left: 0%;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  max-height: 69%;\r\n\r\n  /* For modern browsers (Firefox) */\r\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent; /* thumb color, track color */\r\n  scrollbar-width: thin;\r\n}\r\n\r\n/* For Webkit browsers (Chrome, Safari, Edge) */\r\n.rightScroll::-webkit-scrollbar {\r\n  width: 6px; /* Makes the scrollbar thinner and more elegant */\r\n}\r\n\r\n.rightScroll::-webkit-scrollbar-track {\r\n  background: transparent; /* This is what makes the track transparent */\r\n}\r\n\r\n.rightScroll::-webkit-scrollbar-thumb {\r\n  background-color: rgba(0, 0, 0, 0.2); /* Semi-transparent dark thumb */\r\n  border-radius: 3px; /* Optional: Rounds the corners of the thumb */\r\n}\r\n\r\n.rightScroll::-webkit-scrollbar-thumb:hover {\r\n  background-color: rgba(0, 0, 0, 0.4); /* Slightly darker on hover for interactivity */\r\n}\r\n\r\n.chat-bubble {\r\n  position: relative;\r\n  max-width: 80%;\r\n  padding: 10px 14px;\r\n  border-radius: 14px;\r\n  margin-bottom: 12px;\r\n  line-height: 1.5;\r\n  word-wrap: break-word;\r\n  padding-left: 20px;\r\n}\r\n\r\n.user-bubble {\r\n  width: fit-content;\r\n  background: #e8eaed;\r\n  color: #333;\r\n  align-self: flex-end;\r\n  margin-left: auto;\r\n}\r\n\r\n.ai-bubble {\r\n  color: #222;\r\n  border: 0px solid #ddd;\r\n  align-self: flex-start;\r\n}\r\n\r\n.chat-content{\r\n  font-size: 13px;\r\n}\r\n\r\n.chat-content a {\r\n  color: #007bff;\r\n  text-decoration: underline;\r\n}\r\n\r\n.chat-content::after {\r\n  content: none !important;\r\n  animation: none !important;\r\n}\r\n\r\n\r\n.chat-time-ai {\r\n  font-size: 11px;\r\n  color: #888;\r\n  text-align: left;\r\n  margin-top: 4px;\r\n  padding-left: 0px;\r\n  margin-bottom: -5px;\r\n}\r\n\r\n.chat-time {\r\n  font-size: 11px;\r\n  color: #888;\r\n  text-align: right;\r\n  margin-top: 4px;\r\n  padding-left: 20px;\r\n}\r\n\r\n.send-btn {\r\n  background: transparent;\r\n  border: none;\r\n  margin-left: 4px;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: opacity 0.2s ease;\r\n}\r\n\r\n.send-btn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* 🌐 Globe toggle */\r\n.globe-container {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 6px;\r\n}\r\n\r\n\r\n.globe-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Tooltip */\r\n.globe-tooltip {\r\n  position: absolute;\r\n  bottom: 38px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: white;\r\n  color: #333;\r\n  font-size: 12px;\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n  white-space: nowrap;\r\n  z-index: 50;\r\n}\r\n\r\n/* Simple CSS Tooltip */\r\n.tooltip-container {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.tooltip-container .tooltip-text {\r\n  visibility: hidden;\r\n  background-color: white;\r\n  color: black;\r\n  text-align: center;\r\n  padding: 5px 10px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  \r\n  /* Position the tooltip */\r\n  position: absolute;\r\n  z-index: 1;\r\n  bottom: 100%; /* Position above the element */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  margin-bottom: 5px;\r\n  \r\n  /* Fade in */\r\n  opacity: 0;\r\n  transition: opacity 0.3s;\r\n  \r\n  /* Prevent text selection */\r\n  user-select: none;\r\n  pointer-events: none;\r\n  \r\n  /* White arrow */\r\n  white-space: nowrap;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n}\r\n\r\n.tooltip-container .tooltip-text::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%; /* At the bottom of the tooltip */\r\n  left: 50%;\r\n  margin-left: -5px;\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: white transparent transparent transparent;\r\n\r\n}\r\n\r\n.tooltip-container:hover .tooltip-text {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n/* Dropdown menu */\r\n.data-source-menu {\r\n  position: absolute;\r\n  bottom: 42px;\r\n  left: 0;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n  padding: 8px 0;\r\n  width: 190px;\r\n  z-index: 100;\r\n}\r\n\r\n.data-source-menu hr {\r\n  border: none;\r\n  border-top: 1px solid #eee;\r\n  margin: 4px 0;\r\n}\r\n\r\n.menu-item-int {\r\n  padding: 8px 14px;\r\n  font-size: 13px;\r\n  color: #333;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.menu-item-int:hover {\r\n  background: #E8E9EB;\r\n}\r\n\r\n.check {\r\n  color: #2b6cb0;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Info bawah input */\r\n/* ====== Container info bawah chat ====== */\r\n.selected-info {\r\n  position: relative;\r\n  margin-top: 10px; /* jarak dari chat input */\r\n  left: 0;\r\n  transform: none;\r\n  bottom: 0;\r\n  width: 100%;\r\n  font-size: 13px;\r\n  color: #2b6cb0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-weight: 500;\r\n  justify-content: flex-start;\r\n  padding-left: 10px;\r\n}\r\n\r\n/* Kotak utama sumber aktif */\r\n.source-box {\r\n  background-color: #f1f3f5;\r\n  border-radius: 20px;\r\n  padding: 6px 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease, transform 0.2s ease;\r\n  white-space: nowrap;\r\n  position: relative; /* ini penting agar .source-list posisinya relatif terhadap kotak ini */\r\n}\r\n\r\n.source-box:hover {\r\n  background-color: #e1e5e9;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Daftar badge keluar ke kanan dari kotak sumber */\r\n.source-list {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: calc( var(--source-box-right, 0px) + 270px );\r\n/* muncul persis di sisi kanan .source-box */\r\n  transform: translateY(-50%);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-left: 10px; /* jarak kecil dari box sumber */\r\n  z-index: 10;\r\n}\r\n\r\n.source-item {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background: #F5F5F6;\r\n  color: #0296D2;\r\n  border-radius: 20px;\r\n  padding: 6px 12px 6px 10px;\r\n  margin: -150px;\r\n  font-size: 13px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.source-item:hover{\r\n  background: #E1F2FA;\r\n}\r\n\r\n/* Tombol X kiri */\r\n.remove-btn {\r\n  display: none;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 22px;\r\n  height: 22px;\r\n  margin-right: 6px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  background-color: #b5e0f6;\r\n  color: #007bcb;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  line-height: 0;\r\n  padding: 0;\r\n}\r\n\r\n.source-item:hover .remove-btn {\r\n  display: flex;\r\n}\r\n\r\n.remove-btn:hover {\r\n  background-color: #8dd2f3;\r\n}\r\n\r\n/* Pastikan teks tidak tertabrak tombol */\r\n.source-text {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Tooltip wrapper */\r\n.tooltip-wrapper {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Tooltip text (tersembunyi default) */\r\n.tooltip-text {\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  position: absolute;\r\n  bottom: 120%; /* muncul di atas ikon */\r\n  background-color: #fff;\r\n  color: #000000;\r\n  font-size: 12px;\r\n  padding: 5px 8px;\r\n  border-radius: 6px;\r\n  white-space: nowrap;\r\n  transition: opacity 0.2s ease, transform 0.2s ease;\r\n  transform: translateY(4px);\r\n  z-index: 20;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n}\r\n\r\n\r\n/* Saat hover ke ikon, tooltip muncul */\r\n.tooltip-wrapper:hover .tooltip-text {\r\n  visibility: visible;\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n}\r\n\r\n.typing-indicator {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  margin: 6px 0 10px 6px;\r\n  padding: 6px 12px;\r\n  background: #f3f6fb;\r\n  border-radius: 20px;\r\n  width: fit-content;\r\n}\r\n\r\n.typing-indicator .dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  background: #2b6cb0;\r\n  border-radius: 50%;\r\n  animation: blink 1.4s infinite both;\r\n}\r\n\r\n.typing-indicator .dot:nth-child(2) {\r\n  animation-delay: 0.2s;\r\n}\r\n.typing-indicator .dot:nth-child(3) {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n@keyframes blink {\r\n  0%, 80%, 100% { opacity: 0; }\r\n  40% { opacity: 1; }\r\n}\r\n\r\n/* File preview di dalam input */\r\n.file-preview-inline {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n/* Item file */\r\n.file-item {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  border-radius: 12px;\r\n  background: white;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  padding: -1px;\r\n}\r\n\r\n/* Tombol X */\r\n.remove-file-btn {\r\n  position: absolute;\r\n  top: -6px;\r\n  right: -6px;\r\n  background: #fff;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 50%;\r\n  padding: 0px;\r\n  color: #444;\r\n  width: 25px;\r\n  height: 25px;\r\n  font-size: 25px;\r\n  line-height: 15px;\r\n  cursor: pointer;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.remove-file-btn:hover {\r\n  background: #ff4d4f;\r\n  color: white;\r\n  border-color: #ff4d4f;\r\n}\r\n\r\n/* Baris utama input */\r\n.input-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n}\r\n\r\n/* Textarea */\r\n.input-row textarea {\r\n  flex: 1;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  resize: none;\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n  color: #222;\r\n}\r\n\r\n.input-row textarea::placeholder {\r\n  color: #7a8aa0;\r\n}\r\n\r\n\r\n/* Tombol kirim */\r\n.send-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.source-item {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 4px 8px;\r\n}\r\n\r\n.source-item img {\r\n  opacity: 1;\r\n  transition: opacity 0.2s ease;\r\n}\r\n\r\n.content-cell {\r\n  padding-left: 40px;\r\n  vertical-align: top;\r\n  text-align: left;\r\n}\r\n\r\n.source-item .remove-btn {\r\n  opacity: 0;\r\n  position: absolute;\r\n  left: 0;\r\n  transition: opacity 0.2s ease;\r\n  background: #B5E0F6;\r\n  color: #01648C;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 21px;\r\n  height: 21px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  margin-right: 6px;\r\n  margin-left: 7px;\r\n}\r\n\r\n.source-item:hover img {\r\n  opacity: 0;\r\n}\r\n\r\n.source-item:hover .remove-btn {\r\n  opacity: 1;\r\n}\r\n\r\n.internet-status-icon:hover{\r\n  color: #0296D2;\r\n}\r\n\r\n.hoverclass{\r\n  padding: 2px;\r\n}\r\n\r\n.hoverclass:hover{\r\n  background:#E8E9EB;\r\n  border-radius: 5px;\r\n  padding: 2px;\r\n}\r\n\r\n.chosen{\r\n  background:#D9DBDF;\r\n  border-radius: 5px;\r\n  padding: 2px;\r\n}\r\n\r\n.aiModel{\r\n  color: black;\r\n  font-size: 14px;\r\n  margin-top: 3px;\r\n}\r\n\r\n.aiModel:hover{\r\n  color: #0296D2;\r\n  cursor: pointer;\r\n}\r\n\r\n.aiModel-trigger {\r\n  cursor: pointer;\r\n  width: fit-content;\r\n}\r\n\r\n.aiModel-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  pointer-events: none; /* important */\r\n}\r\n\r\n.aiModel-popup {\r\n  position: absolute;\r\n  bottom: 130px;\r\n  left: 60px;\r\n  pointer-events: auto;\r\n  background-color: white;\r\n  box-shadow: 0px 8px 80px 6px #00000033;\r\n  border-radius: 8px;\r\n  max-height: 200%;\r\n  overflow-y: scroll;\r\n  max-width: 40%;\r\n}\r\n\r\n.aiModel-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 15px;\r\n  cursor: pointer;\r\n  margin: 10px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.aiModel-item:hover {\r\n  background: #E8E9EB;\r\n}\r\n\r\n.aiModel-item.active {\r\n  background: #E8E9EB;\r\n}\r\n\r\n.aiModel-label {\r\n  margin-bottom: 5px;\r\n  font-weight: 600;\r\n  color: #666;\r\n}\r\n\r\n.aiModel-detail {\r\n  font-size: 12px;\r\n  color: #666;\r\n}\r\n\r\n.aiModel-check {\r\n  font-size: 16px;\r\n  color: #666;\r\n}\r\n\r\n.chat-bubble.system {\r\n  background: #fff3cd;\r\n  border: 1px solid #ffe69c;\r\n  color: #664d03;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  max-width: 80%;\r\n  margin: 10px auto;\r\n  text-align: left;\r\n}\r\n\r\n.chat-bubble.system ul {\r\n  padding-left: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
